const config = {
    API_BASE: 'https://telegram.mydo.asia',
    WEB_BASE: '/', // Base path for web interface
    APP_NAME: 'Telegram Dashboard',
    VERSION: '1.0.0'
};

export default config;